import axios from 'axios'

export const getMySurveys = () => {
  return axios.get('/survey/user')
}

export const postSurvey = ({ surveyResponses }) => {
  return axios.post('/survey/response', { ...surveyResponses })
}
